/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPSIGNATORYSTATUS } from './IAPSIGNATORYSTATUS';
import {
    IAPSIGNATORYSTATUSFromJSON,
    IAPSIGNATORYSTATUSFromJSONTyped,
    IAPSIGNATORYSTATUSToJSON,
} from './IAPSIGNATORYSTATUS';
import type { SignatoryViewModel } from './SignatoryViewModel';
import {
    SignatoryViewModelFromJSON,
    SignatoryViewModelFromJSONTyped,
    SignatoryViewModelToJSON,
} from './SignatoryViewModel';

/**
 * 
 * @export
 * @interface SignatoryProgressViewModel
 */
export interface SignatoryProgressViewModel {
    /**
     * 
     * @type {IAPSIGNATORYSTATUS}
     * @memberof SignatoryProgressViewModel
     */
    status: IAPSIGNATORYSTATUS;
    /**
     * 
     * @type {SignatoryViewModel}
     * @memberof SignatoryProgressViewModel
     */
    signatory: SignatoryViewModel;
}

/**
 * Check if a given object implements the SignatoryProgressViewModel interface.
 */
export function instanceOfSignatoryProgressViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "signatory" in value;

    return isInstance;
}

export function SignatoryProgressViewModelFromJSON(json: any): SignatoryProgressViewModel {
    return SignatoryProgressViewModelFromJSONTyped(json, false);
}

export function SignatoryProgressViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatoryProgressViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': IAPSIGNATORYSTATUSFromJSON(json['Status']),
        'signatory': SignatoryViewModelFromJSON(json['Signatory']),
    };
}

export function SignatoryProgressViewModelToJSON(value?: SignatoryProgressViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Status': IAPSIGNATORYSTATUSToJSON(value.status),
        'Signatory': SignatoryViewModelToJSON(value.signatory),
    };
}

